import { useEffect, useState } from "react";

import { NavLink } from "react-router-dom";

import iFavorites from "../../assets/images/100-favorites.svg";
import iLive from "../../assets/images/100-live.svg";
import iPast from "../../assets/images/100-past.svg";
import iUpcoming from "../../assets/images/100-upcoming.svg";
import ToggleButton from "../../components/ToggleButton";
import SearchBox from "../../components/search-box";
import { useLiveWorkspaceCreationContext } from "../../contexts/LiveWorkspaceCreationContext";
import { useApi } from "../../hooks/useApi";

import CourseCard from "./course-card";
import CreationSidebar from "./creation-sidebar";
import MeetingCard from "./meeting-card";

export default function Meeting({ showCreate, filter }) {
  const { getMyMeetings, loadCourses } = useApi();
  const { selectedCourses, setSelectedCourses, meetingList, setMeetingList, courseList, setCourseList } = useLiveWorkspaceCreationContext();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (showCreate) {
      loadCourses().then((courses) => {
        setCourseList(courses);
        setLoading(false);
      });
    } else {
      getMyMeetings({ filter }).then(({ rows }) => {
        // TODO: Handle pagination
        setMeetingList(rows);
        setLoading(false);
      });
    }
  }, [showCreate]);

  return (
    <div className="flex-col w-100p gap-12">
      {/* Top Bar */}
      <div className="space-between align-items-center">
        <div className="align-items-center relative h-52">
          <SearchBox placeholder="workspaces..." />
          <div className="m-l-15 align-items-center">
            <ToggleButton />
          </div>
          <div className="B2-Medium m-l-10 align-items-center">My Workspaces</div>
        </div>

        <div className="flex gap-12">
          <NavLink exact to="/live" className="button button-md button-wh ">
            <span>Show All</span>
          </NavLink>
          <NavLink exact to="/live/active" className="button button-md button-wh ">
            <img src={iLive} className="i-live" alt="" /> <span>Live</span>
          </NavLink>
          <NavLink exact to="/live/upcoming" className="button button-md button-wh ">
            <img src={iUpcoming} className="i-upcoming" alt="" /> <span>Upcoming</span>
          </NavLink>
          <NavLink exact to="/live/past" className="button button-md button-wh ">
            <img src={iPast} className="i-past" alt="" /> <span>past</span>
          </NavLink>
          <div className="button button-md button-wh">
            <img src={iFavorites} className="i-favorites" alt="" /> <span>favorites</span>
          </div>
        </div>
      </div>

      {/* List & Side Bar */}
      <div className={`flex-align-start res-width ${!showCreate ? "flex-dir-initial" : ""}`}>
        <div className={`create-meeting-thumbnails gap-24 ${showCreate ? "with-sidebar" : "without-sidebar"} `}>
          {loading && (
            <div className="create-meeting-thumbnails">
              {Array.from(Array(6)).map((_, i) => (
                <div key={i} className="loading-single-thumbnail loading-animation">
                  <div className="loading-w-165-24-15" />
                  <div>
                    <div className="loading-w-200-24-15" />
                    <div className="loading-w-150-24-15 m-t-15" />
                  </div>
                </div>
              ))}
            </div>
          )}

          {!loading && !showCreate && meetingList.map((meeting, i) => <MeetingCard key={i} meeting={meeting} />)}
          {!loading && !showCreate && !meetingList.length && <div>No meetings found</div>}

          {!loading &&
            showCreate &&
            courseList.map((course, i) => (
              <CourseCard
                key={i}
                course={course}
                selected={selectedCourses.find((sc) => sc.cid === course.cid)}
                onClick={() => {
                  // Toggle course selection
                  setSelectedCourses((prev) => {
                    if (prev.includes(course)) return prev.filter((pc) => pc !== course);
                    return [...prev, course];
                  });
                }}
              />
            ))}
          {!loading && showCreate && !courseList.length && <div>No courses found</div>}
        </div>
        {showCreate && <CreationSidebar />}
      </div>
    </div>
  );
}
